// 面板级动画 hook：SeatPanel/PlayerPanel 消费 fxStore 获取动画 class + 飘字
import { useFxStore, type FxEntry } from "@/store/fxStore";

export interface PanelFx {
  animClass: string;
  floatDmg: number | null;
  animKey: number;
}

export function usePanelFx(playerId: string): PanelFx {
  const entry: FxEntry | undefined = useFxStore((s) => s.map[playerId]);
  return {
    animClass: entry?.class ?? "",
    floatDmg: entry?.dmg ?? null,
    animKey: entry?.key ?? 0,
  };
}
